import { Client } from "../../../client";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { API_RESET_USER_PASSCODE } from "../../../config/api";
import { proccessErrorMessage } from "../../../Helper/proccessErrorMessage";
export const resetPassCode = createAsyncThunk(
  "user/resetPassCode",
  async ({ data, callback, failed }, { dispatch, rejectWithValue }) => {
    try {
      const response = await Client({
        method: "POST",
        path: `${API_RESET_USER_PASSCODE}${data?.user_id}`,
      });

      toast.success(
        response?.data?.message || "User Passcode Reset Successfuly"
      );
      callback();
    } catch (error) {
      const msg = proccessErrorMessage(error);
      toast.error(msg);
      failed();
      return rejectWithValue(error.message);
    }
  }
);
